import React from "react";
import ZoneAdminRevenueTable from "./ZoneAdminRevenueTable";

const Revenue = () => {
  return (
    <div style={{ marginTop: "2rem" }}>
      <ZoneAdminRevenueTable />
    </div>
  );
};

export default Revenue;
